var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoEquityEdge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 44,
    viewBox: "0 0 238 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.89946 43.3925L39.7803 10.5117L32.8807 3.61217L-8.61684e-05 36.493L6.89946 43.3925Z",
    fill: "url(#paint0_linear_1_2620)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89946 43.3925L39.7803 10.5117L32.8807 3.61217L-8.61684e-05 36.493L6.89946 43.3925Z",
    fill: "url(#paint1_linear_1_2620)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49608 33.6555V16.7171H0.00976562V33.6555C0.00976562 38.8948 4.25677 43.1417 9.49608 43.1417H26.4344V33.6555H9.49608ZM33.3318 0.333496H9.49608C4.25677 0.333496 0.00976562 4.58043 0.00976562 9.81973V9.83205H33.3318V43.1417C38.5711 43.1417 42.8181 38.8948 42.8181 33.6555V9.81973C42.8181 4.58043 38.5711 0.333496 33.3318 0.333496Z",
    fill: "#36D66B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.437 13.573V18.5346H66.0993V21.6807H59.437V26.9262H66.9511V30.1584H55.4678V10.3408H66.9511V13.573H59.437Z",
    fill: "#36D66B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7116 33.6438L83.706 30.0445C82.8743 30.251 82.0254 30.3571 81.1535 30.3571C79.3008 30.3571 77.6001 29.9212 76.0485 29.0522C74.4998 28.1832 73.2695 26.9787 72.3633 25.4386C71.457 23.8985 71.001 22.1548 71.001 20.2074C71.001 18.2601 71.4541 16.5451 72.3633 15.005C73.2695 13.4649 74.4998 12.2603 76.0485 11.3913C77.5972 10.5224 79.3008 10.0864 81.1535 10.0864C83.0062 10.0864 84.7299 10.5224 86.27 11.3913C87.8101 12.2603 89.029 13.4649 89.9266 15.005C90.8243 16.5451 91.2717 18.2802 91.2717 20.2074C91.2717 21.9655 90.8988 23.5658 90.1531 25.0141C89.4075 26.4596 88.3894 27.6354 87.1045 28.5446L91.6417 33.6467H86.7088L86.7116 33.6438ZM75.8535 23.692C76.364 24.6929 77.0781 25.4644 77.993 26.0036C78.9108 26.5428 79.9633 26.8124 81.1564 26.8124C82.3495 26.8124 83.3963 26.5428 84.3025 26.0036C85.2088 25.4644 85.9172 24.6958 86.4277 23.692C86.9382 22.6911 87.1935 21.5296 87.1935 20.2046C87.1935 18.8796 86.9382 17.7238 86.4277 16.7315C85.9172 15.7392 85.2088 14.9792 84.3025 14.4486C83.3963 13.9209 82.3466 13.6542 81.1564 13.6542C79.9662 13.6542 78.9108 13.918 77.993 14.4486C77.0753 14.9763 76.364 15.7392 75.8535 16.7315C75.343 17.7238 75.0878 18.8824 75.0878 20.2046C75.0878 21.5267 75.343 22.6911 75.8535 23.692Z",
    fill: "#36D66B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6178 10.3696V22.6158C99.6178 23.958 99.9676 24.9819 100.667 25.6903C101.367 26.3986 102.348 26.7543 103.616 26.7543C104.883 26.7543 105.893 26.3986 106.593 25.6903C107.292 24.9819 107.642 23.958 107.642 22.6158V10.3696H111.64V22.59C111.64 24.2735 111.276 25.6931 110.548 26.8575C109.819 28.019 108.847 28.8938 107.628 29.4788C106.409 30.0639 105.053 30.3593 103.561 30.3593C102.07 30.3593 100.751 30.0668 99.5489 29.4788C98.3501 28.8938 97.3979 28.019 96.701 26.8575C96.0012 25.696 95.6514 24.2735 95.6514 22.59V10.3696H99.6206H99.6178Z",
    fill: "#36D66B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M120.854 10.3696V30.1585H116.885V10.3696H120.854Z",
    fill: "#36D66B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M139.635 10.3696V13.5731H134.361V30.1585H130.391V13.5731H125.117V10.3696H139.632H139.635Z",
    fill: "#36D66B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M160.808 10.3696L154.117 23.2697V30.1585H150.147V23.2697L143.428 10.3696H147.908L152.161 19.4123L156.385 10.3696H160.808Z",
    fill: "#36D66B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M168.988 13.533V18.4945H175.65V21.6407H168.988V26.8862H176.502V30.1184H165.019V10.3008H176.502V13.533H168.988Z",
    fill: "#36D66B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M193.924 11.5485C195.502 12.3601 196.721 13.5188 197.581 15.0216C198.441 16.5244 198.872 18.2681 198.872 20.2527C198.872 22.2373 198.441 23.9725 197.581 25.4552C196.721 26.9379 195.502 28.088 193.924 28.8996C192.347 29.7112 190.517 30.1185 188.438 30.1185H181.521V10.3296H188.438C190.517 10.3296 192.347 10.7368 193.924 11.5485ZM193.116 25.0422C194.251 23.9094 194.816 22.3119 194.816 20.2499C194.816 18.1878 194.249 16.5789 193.116 15.4145C191.983 14.2529 190.377 13.6708 188.297 13.6708H185.493V26.74H188.297C190.377 26.74 191.983 26.1722 193.116 25.0393V25.0422Z",
    fill: "#36D66B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M217.037 16.2835C216.584 15.4518 215.959 14.8179 215.164 14.3849C214.373 13.949 213.447 13.7339 212.388 13.7339C211.215 13.7339 210.177 13.9977 209.268 14.5283C208.362 15.0589 207.653 15.8131 207.143 16.7968C206.632 17.7805 206.377 18.9134 206.377 20.1982C206.377 21.4831 206.638 22.6733 207.157 23.657C207.676 24.6407 208.399 25.395 209.325 25.9255C210.252 26.4561 211.327 26.72 212.558 26.72C214.069 26.72 215.308 26.3185 216.272 25.5154C217.235 24.7124 217.869 23.591 218.17 22.1542H211.367V19.1199H222.085V22.5786C221.818 23.9581 221.253 25.2344 220.384 26.4074C219.515 27.5804 218.394 28.5182 217.026 29.2294C215.655 29.9378 214.121 30.2934 212.42 30.2934C210.51 30.2934 208.786 29.8632 207.246 29.0029C205.706 28.1425 204.496 26.9465 203.618 25.4179C202.738 23.8864 202.299 22.1484 202.299 20.2011C202.299 18.2538 202.738 16.51 203.618 14.97C204.496 13.4299 205.706 12.2282 207.246 11.3707C208.786 10.5103 210.501 10.0801 212.391 10.0801C214.62 10.0801 216.558 10.6221 218.202 11.7091C219.845 12.796 220.981 14.3218 221.603 16.2863H217.04L217.037 16.2835Z",
    fill: "#36D66B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M230.414 13.533V18.4945H237.076V21.6407H230.414V26.8862H237.928V30.1184H226.444V10.3008H237.928V13.533H230.414Z",
    fill: "#36D66B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2620",
    x1: 2.14039,
    y1: 38.9513,
    x2: 37.6383,
    y2: 8.04554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#D6DAD7",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#616F64",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#1B3021",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#071E0D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_2620",
    x1: 2.14107,
    y1: 38.9551,
    x2: 37.6328,
    y2: 8.04932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#071E0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#134E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#1D773A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#26994C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#2DB459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#32C763"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#35D269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36D66B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEquityEdge);
export default __webpack_public_path__ + "static/media/logoEquityEdge.d010301ff0551d71d51f653a84e50a60.svg";
export { ForwardRef as ReactComponent };